import React from "react";
import { useTranslation } from "react-i18next";

import { fromDayMarker, getDaysTexts } from "../utils";
import { Week } from "../week";
import { Props } from "./types";
import styles from "./styles.scss";

function MonthlyView({ date, weeks, filter }: Props) {
  const { t } = useTranslation();
  const daysNames = getDaysTexts(t);
  const dateKey = fromDayMarker(date).toFormat("yyyy-MM-dd");

  return (
    <div className={styles.monthlyView}>
      <div className={styles.labels}>
        <h3 className={styles.dayName}>{daysNames[0]}</h3>
        <h3 className={styles.dayName}>{daysNames[1]}</h3>
        <h3 className={styles.dayName}>{daysNames[2]}</h3>
        <h3 className={styles.dayName}>{daysNames[3]}</h3>
        <h3 className={styles.dayName}>{daysNames[4]}</h3>
        <h3 className={styles.dayName}>{daysNames[5]}</h3>
        <h3 className={styles.dayName}>{daysNames[6]}</h3>
      </div>
      {weeks.map(
        (
          {
            week,
            events,
            milestones,
            unavailabilities,
            calendarsHolidays,
            tasks,
          },
          index,
        ) => (
          <Week
            key={`${index}__${dateKey}`}
            week={week}
            filter={filter}
            events={events}
            unavailabilities={unavailabilities}
            milestones={milestones}
            calendarsHolidays={calendarsHolidays}
            tasks={tasks}
          />
        ),
      )}
    </div>
  );
}

export { MonthlyView };
